(ns app.domain.party-role.model
  "Model for party roles as entities (and not just keywords)"
  (:require [app.domain.group.model :as group-model]
            [app.i18n.model :as i18n-model]
            [potpuri.core :as p]))

(def ^{:arglists '([party-role lang])} party-role-name
  "Use `app.front.view.party.common/party-role-label` in the frontend"
  (i18n-model/translation-fallback-fn :party-role/names))

(defmethod i18n-model/get-localized-string-attrs :entity.type/party-role [_]
  [:party-role/names])

(defmethod group-model/get-authority-group :entity.type/party-role
  [party-role]
  (:party-role/authority-group party-role))

(defn get-role-with-key
  "Returns the party role entity related to the given role keyword (e.g. :role/applicant)"
  [auth-group key]
  (-> auth-group
      :party-role/_authority-group
      (p/find-first {:party-role/key key})))
